import { Info } from 'lucide-react';
import { TERMS_URL } from '@/constants';
import { Dialog, DialogContent } from '@/components/ui/dialog.jsx';
import { useUpdateProfileMutation } from '@/store/api';
import { UsersDto } from '@sportspredict/shared';
import { openUrlInDefaultBrowser } from '@/utils/device/wtn.util';

interface NewTermsDialogProps {
	user: UsersDto;
	open: boolean;
	onAgree: () => void;
}

export default function NewTermsDialog({ user, open, onAgree }: NewTermsDialogProps) {
	const [updateProfile, { isLoading }] = useUpdateProfileMutation();

	const handleAgree = async () => {
		try {
			await updateProfile({
				id: user.id,
				viewed_popups: { ...user.viewed_popups, accepted_latest_terms: true },
			}).unwrap();
			onAgree();
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Dialog
			open={open}
			onOpenChange={() => {
				//
			}}
		>
			<DialogContent
				disableClose
				className="max-w-[361px] rounded-[16px]! border border-[#DCE3F9] pt-8 px-4 pb-4 overflow-hidden"
				style={{
					background: 'linear-gradient(148.82deg, #FFFFFF 49.94%, #DCE3F9 100%)',
				}}
			>
				<div className="flex flex-col gap-8 items-start w-full">
					<div className="flex flex-col gap-3 items-center w-full">
						<div className="bg-[#DCE3F9] flex items-center justify-center rounded-full size-12">
							<Info className="text-blue-custom-2" size={24} />
						</div>
						<p className="font-bold text-[22px] leading-[34px] tracking-[-0.028em] text-[#0A0A0A] text-center w-full orbitron">
							We&apos;ve updated our
							<br />
							Terms and Conditions
						</p>
					</div>

					<div className="flex flex-col gap-6 items-start w-full">
						<div className="text-center w-full ">
							<p className="font-['DM_Sans'] text-[14px] leading-[20px] tracking-[-0.026em] text-[#848484] font-medium">
								By continuing, you agree to the updated
							</p>
							<button
								type="button"
								onClick={() => openUrlInDefaultBrowser(TERMS_URL)}
								className="font-['DM_Sans'] text-[14px] leading-[20px] tracking-[-0.026em] text-[#5583F6] font-medium hover:underline transition-colors"
							>
								Terms &amp; Conditions.
							</button>
						</div>

						<button
							disabled={isLoading}
							onClick={handleAgree}
							className="bg-blue-custom-2 border border-[#5583F6] text-white h-10 w-full rounded-[8px] text-sm font-semibold font-['Poppins'] hover:bg-[#1b58f5] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3"
							style={{
								boxShadow:
									'0px 8px 16px 0px rgba(38,103,255,0.24), 0px 2px 6px 0px rgba(0,0,0,0.15)',
							}}
						>
							{isLoading ? (
								<>
									<span className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
									Saving...
								</>
							) : (
								'Agree & Continue'
							)}
						</button>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
}
